import Button from "@mui/material/Button";
import React from "react";
import Link from "./ui/RouterLink";
export default class RouteErrorBoundary extends React.Component {
  state = {
    failed: false,
  };
  static getDerivedStateFromError() {
    return {
      failed: true,
    };
  }
  componentDidUpdate(previous) {
    if (previous.resetKey !== this.props.resetKey && this.state.failed) {
      this.setState({
        failed: false,
      });
    }
  }
  render() {
    if (this.state.failed) {
      return (
        <section role="alert">
          <h2>This page could not be displayed</h2>
          <p>Try again or return to your collection.</p>
          <Button
            className="btn"
            onClick={() =>
              this.setState({
                failed: false,
              })
            }
          >
            Try again
          </Button>{" "}
          <Link to="/">Return to collection</Link>
        </section>
      );
    }
    return this.props.children;
  }
}
